import { bindingKey, type Binding } from "../bindings.ts";

// Coupled venue+pair selector: one entry per (venue, pair) binding.
// Presentational — the caller supplies the (identity-scoped) options.
interface Props {
  value: Binding;
  onChange: (b: Binding) => void;
  options: Binding[];
}

export function VenuePairSelector({ value, onChange, options }: Props) {
  return (
    <label className="selector">
      <span>Market</span>
      <select
        value={bindingKey(value)}
        onChange={(e) => {
          const b = options.find((x) => bindingKey(x) === e.target.value);
          if (b) onChange(b);
        }}
      >
        {options.map((b) => (
          <option key={bindingKey(b)} value={bindingKey(b)}>
            {b.label}
          </option>
        ))}
      </select>
    </label>
  );
}
